import { type CustomerEntity, EntityTypeEnum } from '@/types/generated'

export function formatEntityName(
  entity: CustomerEntity | null | undefined,
  fallback: string = 'Unnamed'
): string {
  if (!entity) return fallback

  switch (entity.entity_type) {
    case EntityTypeEnum.NATURAL_PERSON: {
      const name =
        `${entity.title || ''} ${entity.first_name || ''} ${entity.last_name || ''}`.trim()
      return name || fallback
    }
    case EntityTypeEnum.LEGAL_PERSON:
      return entity.company_name || fallback
    case EntityTypeEnum.INSTITUTION:
      return entity.institution_name || fallback
    default:
      return fallback
  }
}
